import React, { useMemo, useState } from "react";
import { Box, Typography, Button, TextField } from "@mui/material";
import { MaterialReactTable, type MRT_ColumnDef } from 'material-react-table';
import { useNavigate, useLocation } from "react-router-dom";

const tableData = [
    {
        id: 1,
        company: "JMCC",
        plannedStartDate: "05/01/2025",
        plannedCompletionDate: "08/13/2025",
        actualStartDate: "12/30/1899",
        actualCompletionDate: "06/26/2025",
        subRows: [
            {
                id: "1.1",
                building: "Admin & Cost Building",
                plannedStartDate: "05/01/2025",
                plannedCompletionDate: "08/13/2025",
                actualStartDate: "12/30/1899",
                actualCompletionDate: "06/26/2025",
                anticipatedCompletionDate: "08/20/2025",
                expectedDelay: 6,
                progresspercentage: "50.64%",
                subRows: [
                    {
                        id: "1.1.1",
                        activity: "Exacavation",
                        uom: "cum",
                        plannedStartDate: "05/01/2025",
                        plannedCompletionDate: "06/11/2025",
                        actualCompletionDate: "06/11/2025",
                        totalScope: 219,
                        expectedDelay: 0,
                        progresstilldate: 219,
                        progresspercentage: "100.00%",
                        balance: 0,
                    },
                    {
                        id: "1.1.2",
                        activity: "RCC of Foundation",
                        uom: "cum",
                        plannedStartDate: "05/06/2025",
                        plannedCompletionDate: "06/26/2025",
                        actualCompletionDate: "06/26/2025",
                        totalScope: 219,
                        expectedDelay: 0,
                        progresstilldate: 219,
                        progresspercentage: "100.00%",
                        balance: 0,
                    },
                    {
                        id: "1.1.3",
                        activity: "BOLT FIXING",
                        uom: "Nos",
                        plannedStartDate: "05/14/2025",
                        plannedCompletionDate: "07/16/2025",
                        anticipatedCompletionDate: "07/25/2025",
                        totalScope: 202,
                        expectedDelay: 9,
                        progresstilldate: 101,
                        progresspercentage: "50.00%",
                        balance: 101,
                    },
                ],
            },
            {
                id: "1.2",
                building: "Canteen Building",
                plannedStartDate: "05/01/2025",
                plannedCompletionDate: "08/14/2025",
                actualCompletionDate: "06/26/2025",
                expectedDelay: 4,
                actualStartDate: "12/30/1899",
                anticipatedCompletionDate: "8/22/2025",
                progresspercentage: "53.65%",
                subRows: [
                    {
                        id: "1.2.1",
                        uom: "cum",
                        plannedStartDate: "05/01/2025",
                        plannedCompletionDate: "06/11/2025",
                        actualCompletionDate: "6/11/2025",
                        totalScope: 183,
                        expectedDelay: 0,
                        progresstilldate: 183,
                        progresspercentage: "100.00%",
                        balance: 0,
                    },
                    {
                        id: "1.2.2",
                        uom: "cum",
                        plannedStartDate: "5/6/2025",
                        plannedCompletionDate: "6/26/2025",
                        actualCompletionDate: "06/26/2025",
                        totalScope: 183,
                        expectedDelay: 0,
                        progresstilldate: 183,
                        progresspercentage: "100.00%",
                        balance: 0,
                    },
                    {
                        id: "1.2.3",
                        uom: "Nos",
                        plannedStartDate: "5/14/2025",
                        plannedCompletionDate: "7/16/2025",
                        anticipatedCompletionDate: "7/20/2025",
                        totalScope: 161,
                        expectedDelay: 4,
                        progresstilldate: 109,
                        progresspercentage: "67.70%",
                        balance: 52,
                    },
                ],
            },
        ],
    },
    {
        id: 2,
        company: "PN Construction",
        plannedStartDate: "5/14/2025",
        plannedCompletionDate: "8/19/2025",
        actualStartDate: "12/30/1899",
        actualCompletionDate: "12/30/1899",
        subRows: [
            {
                id: "2.1",
                building: "Pre-Cast Boundary Wall",
                plannedStartDate: "5/14/2025",
                plannedCompletionDate: "8/19/2025",
                actualStartDate: "12/30/1899",
                actualCompletionDate: "12/30/1899",
                anticipatedCompletionDate: "7/17/2025",
                expectedDelay: -14,
                progresspercentage: "43.76%",
                subRows: [
                    {
                        id: "2.1.1",
                        activity: "Excavation",
                        uom: "Nos",
                        plannedStartDate: "5/14/2025",
                        plannedCompletionDate: "6/25/2025",
                        anticipatedCompletionDate: "7/9/2025",
                        totalScope: 116,
                        expectedDelay: 14,
                        progresstilldate: 115,
                        progresspercentage: "99.14%",
                        balance: 1,
                    },
                    {
                        id: "2.1.2",
                        activity: "RCC OF FOUNDATION",
                        uom: "Nos",
                        plannedStartDate: "5/21/2025",
                        plannedCompletionDate: "6/30/2025",
                        anticipatedCompletionDate: "7/10/2025",
                        totalScope: 116,
                        expectedDelay: 10,
                        progresstilldate: 113,
                        progresspercentage: "97.41%",
                        balance: 3,
                    },
                    {
                        id: "2.1.3",
                        activity: "RCC OF PEDESTAL",
                        uom: "Nos",
                        plannedStartDate: "5/27/2025",
                        plannedCompletionDate: "7/7/2025",
                        anticipatedCompletionDate: "7/11/2025",
                        totalScope: 132,
                        expectedDelay: 4,
                        progresstilldate: 104,
                        progresspercentage: "78.79%",
                        balance: 28,
                    },
                ],
            },
        ],
    },
    {
        id: 3,
        company: "Swanil Engineering",
        plannedStartDate: "5/14/2025",
        plannedCompletionDate: "8/19/2025",
        actualStartDate: "12/30/1899",
        actualCompletionDate: "12/30/1899",
        subRows: [
            {
                id: "3.1",
                building: "Drainage System/ Nala Boundary Wall",
                plannedStartDate: "5/14/2025",
                plannedCompletionDate: "8/19/2025",
                actualStartDate: "12/30/1899",
                actualCompletionDate: "12/30/1899",
                anticipatedCompletionDate: "7/17/2025",
                expectedDelay: -14,
                progresspercentage: "43.76%",
                subRows: [
                    {
                        id: "3.1.1",
                        activity: "EXCAVATION",
                        uom: "Nos",
                        plannedStartDate: "5/14/2025",
                        plannedCompletionDate: "6/25/2025",
                        anticipatedCompletionDate: "7/9/2025",
                        totalScope: 116,
                        expectedDelay: 14,
                        progresstilldate: 115,
                        progresspercentage: "99.14%",
                        balance: 1,
                    },
                    {
                        id: "3.1.2",
                        activity: "RCC OF FOUNDATION",
                        uom: "Nos",
                        plannedStartDate: "5/21/2025",
                        plannedCompletionDate: "6/30/2025",
                        anticipatedCompletionDate: "7/10/2025",
                        totalScope: 116,
                        expectedDelay: 10,
                        progresstilldate: 113,
                        progresspercentage: "97.41%",
                        balance: 3,
                    },
                    {
                        id: "3.1.3",
                        activity: "RCC OF PEDESTAL",
                        uom: "Nos",
                        plannedStartDate: "5/27/2025",
                        plannedCompletionDate: "7/7/2025",
                        anticipatedCompletionDate: "7/11/2025",
                        totalScope: 202,
                        expectedDelay: 4,
                        progresstilldate: 104,
                        progresspercentage: "78.79%",
                        balance: 28,
                    },
                ],
            },
            {
                id: "3.2",
                building: "Boundary Wall in common Region",
                plannedStartDate: "5/14/2025",
                plannedCompletionDate: "8/19/2025",
                actualStartDate: "12/30/1899",
                actualCompletionDate: "12/30/1899",
                expectedDelay: -14,
                anticipatedCompletionDate: "7/17/2025",
                progresspercentage: "43.76%",
                subRows: [
                    {
                        id: "3.2.1",
                        activity: "EXCAVATION",
                        uom: "Nos",
                        plannedStartDate: "5/14/2025",
                        plannedCompletionDate: "6/25/2025",
                        anticipatedCompletionDate: "7/9/2025",
                        totalScope: 116,
                        expectedDelay: 14,
                        progresstilldate: 115,
                        progresspercentage: "99.14%",
                        balance: 1,
                    },
                    {
                        id: "3.2.2",
                        activity: "RCC OF FOUNDATION",
                        uom: "Nos",
                        plannedStartDate: "5/21/2025",
                        plannedCompletionDate: "6/30/2025",
                        anticipatedCompletionDate: "7/10/2025",
                        totalScope: 116,
                        expectedDelay: 10,
                        progresstilldate: 113,
                        progresspercentage: "97.41%",
                        balance: 3,
                    },
                    {
                        id: "3.2.3",
                        activity: "RCC OF PEDESTAL",
                        uom: "Nos",
                        plannedStartDate: "5/27/2025",
                        plannedCompletionDate: "7/7/2025",
                        anticipatedCompletionDate: "7/11/2025",
                        totalScope: 132,
                        expectedDelay: 4,
                        progresstilldate: 104,
                        progresspercentage: "78.79%",
                        balance: 28,
                    },
                ],
            },
        ],
    },
    {
        id: 4,
        company: "MS Engineering",
        plannedStartDate: "5/1/2025",
        plannedCompletionDate: "8/13/2025",
        actualStartDate: "12/30/1899",
        actualCompletionDate: "6/26/2025",
        subRows: [
            {
                id: "4.1",
                building: "Admin & Cost Building",
                plannedStartDate: "5/1/2025",
                plannedCompletionDate: "8/13/2025",
                actualStartDate: "12/30/1899",
                actualCompletionDate: "6/26/2025",
                anticipatedCompletionDate: "8/20/2025",
                expectedDelay: 6,
                progresspercentage: "50.64%",
                subRows: [
                    {
                        id: "4.1.1",
                        activity: "Exacavation",
                        uom: "cum",
                        plannedStartDate: "5/1/2025",
                        plannedCompletionDate: "6/11/2025",
                        actualCompletionDate: "6/11/2025",
                        totalScope: 219,
                        expectedDelay: 0,
                        progresstilldate: 219,
                        progresspercentage: "100.00%",
                        balance: 0,
                    },
                    {
                        id: "4.1.2",
                        activity: "RCC of Foundation",
                        uom: "cum",
                        plannedStartDate: "5/6/2025",
                        plannedCompletionDate: "6/26/2025",
                        actualCompletionDate: "6/26/2025",
                        totalScope: 219,
                        expectedDelay: 0,
                        progresstilldate: 219,
                        progresspercentage: "100.00%",
                        balance: 0,
                    },
                    {
                        id: "4.1.3",
                        activity: "BOLT FIXING",
                        uom: "Nos",
                        plannedStartDate: "5/14/2025",
                        plannedCompletionDate: "7/16/2025",
                        anticipatedCompletionDate: "7/25/2025",
                        totalScope: 202,
                        expectedDelay: 9,
                        progresstilldate: 101,
                        progresspercentage: "50.00%",
                        balance: 101,
                    },
                ],
            },
            {
                id: "4.2",
                building: "Canteen Building",
                plannedStartDate: "5/1/2025",
                plannedCompletionDate: "8/14/2025",
                actualStartDate: "12/30/1899",
                actualCompletionDate: "6/26/2025",
                expectedDelay: 4,
                anticipatedCompletionDate: "8/22/2025",
                progresspercentage: "53.65%",
                subRows: [
                    {
                        id: "4.2.1",
                        uom: "cum",
                        plannedStartDate: "5/1/2025",
                        plannedCompletionDate: "6/11/2025",
                        actualCompletionDate: "6/11/2025",
                        totalScope: 183,
                        expectedDelay: 0,
                        progresstilldate: 183,
                        progresspercentage: "100.00%",
                        balance: 0,
                    },
                    {
                        id: "4.2.2",
                        uom: "cum",
                        plannedStartDate: "5/6/2025",
                        plannedCompletionDate: "6/26/2025",
                        actualCompletionDate: "6/26/2025",
                        totalScope: 183,
                        expectedDelay: 0,
                        progresstilldate: 183,
                        progresspercentage: "100.00%",
                        balance: 0,
                    },
                    {
                        id: "4.2.3",
                        uom: "Nos",
                        plannedStartDate: "5/14/2025",
                        plannedCompletionDate: "7/16/2025",
                        anticipatedCompletionDate: "7/20/2025",
                        totalScope: 161,
                        expectedDelay: 4,
                        progresstilldate: 109,
                        progresspercentage: "67.70%",
                        balance: 52,
                    },
                ],
            },
        ],
    },
];

function ViewDPR() {

    const location = useLocation();
    const { dprDate } = location.state || {};

    const navigate = useNavigate();

    const columns = useMemo(
        () => [

            {
                header: "Details",
                muiTableHeadCellProps: {
                    sx: {
                        backgroundColor: "#E3F2FD",
                        fontWeight: "bold",
                        textAlign: "center",
                        border: "1px solid #DADADA",
                    },
                },
                columns: [
                    { accessorKey: 'company', header: 'Level 1', size: 150 },
                    { accessorKey: 'building', header: 'Level 2', size: 150 },
                    { accessorKey: 'activity', header: 'Activity', size: 150 },
                    { accessorKey: 'uomno', header: 'UOM (nos.)', size: 100 },
                    { accessorKey: 'uom', header: 'UOM', size: 100 },
                ]
            },

            {
                header: "Planned Contractor",
                muiTableHeadCellProps: {
                    sx: {
                        backgroundColor: "#E3F2FD",
                        fontWeight: "bold",
                        textAlign: "center",
                        border: "1px solid #DADADA",
                    },
                },
                columns: [
                    { accessorKey: 'plannedStartDate', header: 'Planned SD', size: 120 },
                    { accessorKey: 'plannedCompletionDate', header: 'Planned ComDT', size: 120 },
                    { accessorKey: 'rate', header: 'Rate', size: 100 },
                ]
            },

            {
                header: "Actual/Revised",
                muiTableHeadCellProps: {
                    sx: {
                        backgroundColor: "#E3F2FD",
                        fontWeight: "bold",
                        textAlign: "center",
                        border: "1px solid #DADADA",
                    },
                },
                columns: [
                    { accessorKey: 'actualStartDate', header: 'Actual SD', size: 120 },
                    { accessorKey: 'actualCompletionDate', header: 'Actual ComDT', size: 120 },
                    { accessorKey: 'anticipatedCompletionDate', header: 'Anc ComDT', size: 120 },
                    { accessorKey: 'expectedDelay', header: 'Expected Delay', size: 100 },
                    { accessorKey: 'totalScope', header: 'Total Scope', size: 100 },
                    { accessorKey: 'progresstilldate', header: 'Progress TDT', size: 100 },
                    { accessorKey: 'progresspercentage', header: 'Progress %', size: 100 },
                    { accessorKey: 'balance', header: 'Balance', size: 100 },
                    { accessorKey: 'currentrate', header: 'Curr Rate', size: 100 },
                    { accessorKey: 'requiredrate', header: 'Req Rate', size: 100 },
                ]
            },

            {
                header: "Last Month Progress",
                muiTableHeadCellProps: {
                    sx: {
                        backgroundColor: "#E3F2FD",
                        fontWeight: "bold",
                        textAlign: "center",
                        border: "1px solid #DADADA",
                    },
                },
                columns: [
                    { accessorKey: 'lmpplanned', header: 'LMP Planned', size: 100 },
                    { accessorKey: 'lmpachieved', header: 'LMP Achieved', size: 100 },
                    { accessorKey: 'lmpdiff', header: 'LMP Diff', size: 100 },
                ]
            },

            {
                header: "This Month Progress",
                muiTableHeadCellProps: {
                    sx: {
                        backgroundColor: "#E3F2FD",
                        fontWeight: "bold",
                        textAlign: "center",
                        border: "1px solid #DADADA",
                    },
                },
                columns: [
                    { accessorKey: 'plannedformonth', header: 'Planned for Month', size: 100 },
                    { accessorKey: 'plannedfortoday', header: 'Planned for Today', size: 120 },
                    { accessorKey: 'progresstoday', header: 'Progress Today', size: 120 },
                    { accessorKey: 'plannedtilltoday', header: 'Planned till Today', size: 100 },
                    { accessorKey: 'progresstilltoday', header: 'Progress Till Today', size: 100 },
                    { accessorKey: 'monthdiff', header: 'Diff', size: 100 },
                ],
            },
        ],
        []
    );

    return (
        <Box
            sx={{
                flexGrow: 1,
                width: "100%",
                overflowX: "auto",
                display: "flex",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    mt: 3,
                    p: { xs: 1, sm: 2 },
                    width: "100%",
                    //maxWidth: 1290,
                    boxSizing: "border-box",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        mb: 1,
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            mb: 1,
                        }}
                    >
                        <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: "#5F5F5F" }}>
                            View DPR
                        </Typography>
                        <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                        <Typography sx={{ mb: 1, fontWeight: 600, color: "#84919A", fontSize: "16px" }}>DPR Date: </Typography>
                        <Typography sx={{ fontWeight: 400, color: "#84919A", fontSize: "14px", pt: "2px" }}> {dprDate}</Typography>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            mt: 4,
                        }}
                    >
                        <Button
                            onClick={() => navigate("/projects/10b9ff2d-8d78-44c4-96b4-26ba2cc35f13/dpr/physical-progress")}
                            variant="contained"
                            sx={{
                                backgroundColor: "#00344C",
                                borderRadius: "25px",
                                textTransform: "none",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: "100%",
                                fontFamily: "Outfit, sans-serif",
                                color: "#FFFFFF",
                                px: "18px",
                                py: "12px",
                            }}
                        >
                            Back
                        </Button>
                    </Box>
                </Box>

                <MaterialReactTable
                    columns={columns}
                    data={tableData}
                    enableExpanding
                    enableExpandAll
                    initialState={{ expanded: false }}
                    enableFullScreenToggle={false}
                    enableColumnPinning
                    initialState={{
                        columnPinning: { left: ["mrt-row-expand", "company", "building", "activity"] },
                    }}
                />

            </Box>
        </Box >
    );
}

export default ViewDPR;